'use client'
import { hasPendingMfaAction } from '../hasPendingMfaAction/hasPendingMfaAction.js';

const hasPendingRequirements = (user) => { var _a; return Boolean((_a = user.missingFields) === null || _a === void 0 ? void 0 : _a.length) || hasPendingMfaAction(user); };

export { hasPendingRequirements };
